import { Navigate, Route, Routes } from 'react-router-dom';

import { useEffect, useState } from 'react';

import { AboutUs, Admin, Calendar, Home, Main, MatchesCompetition, Membership, RangeCamera, Newsletters, Signup, VerifyEmail, Visitors, FAQ, Shotgun, RiflePistol, CowboySilhouette, BowlingPinMatch, BlackPowderSilhouette, NraActionPistol, RangeRules, CmpHighpower, TrapLeague, SkeetLeague, FiveStandLeague, Tournaments, MatchManagement, CreateMatch, ResultsEntry, CreateFormat, FormatsList, EditFormat, EditMatch, CmpHighpowerSchedule, CowboySilhouetteSchedule, BlackPowderSilhouetteSchedule, NRAActionPistolSchedule, BowlingPinMatchSchedule } from '../../Pages';
import { FiveStandLeagueInfo } from '../../Pages/MatchesCompetition/FiveStandLeague/Info';
import { FiveStandLeagueResults } from '../../Pages/MatchesCompetition/FiveStandLeague/Results';
import { TrapLeagueInfo } from '../../Pages/MatchesCompetition/TrapLeague/Info';
import { TrapLeagueResults } from '../../Pages/MatchesCompetition/TrapLeague/Results';
import { SkeetLeagueInfo } from '../../Pages/MatchesCompetition/SkeetLeague/Info';
import { SkeetLeagueResults } from '../../Pages/MatchesCompetition/SkeetLeague/Results';
import { TournamentInfo } from '../../Pages/MatchesCompetition/Tournaments/Info';
import { TournamentResults } from '../../Pages/MatchesCompetition/Tournaments/Results';
import { CowboySilhouetteResults } from '../../Pages/MatchesCompetition/CowboySilhouette/Results';
import { BowlingPinMatchResults } from '../../Pages/MatchesCompetition/BowlingPinMatch/Results';
import { CmpHighpowerResults } from '../../Pages/MatchesCompetition/CmpHighpower/Results';
import { NRAActionPistolResults } from '../../Pages/MatchesCompetition/NRAActionPistol/Results';
import { BlackPowderSilhouetteResults } from '../../Pages/MatchesCompetition/BlackPowderSilhouette/Results';
import { CmpRiflePurchase } from '../../Pages/MatchesCompetition/CmpHighpower/RiflePurchase';
import { MembershipForm } from '../../Pages/MatchesCompetition/CmpHighpower/RiflePurchase/MembershipForm';

// All content now loaded dynamically from the content management API

import { useUser } from '../../Context';

export const AppRoutes = () => {
  const { user } = useUser();

  const [isAdmin, setIsAdmin] = useState(false);

  const groups = user?.signInUserSession?.accessToken?.payload?.['cognito:groups'];

  useEffect(() => {
    setIsAdmin(groups?.includes('admins') || groups?.includes('match_directors'));
  }, [user]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />

      {isAdmin && (
        <Route path="/admin" element={<Admin />} />
      )}

      {/* Match Management Routes - Protected for match_directors and admins */}
      {isAdmin && (
        <Route path="matches/manage">
          <Route index element={<MatchManagement />} />
          <Route path="new" element={<CreateMatch />} />
          <Route path=":matchId/edit" element={<EditMatch />} />
          <Route path=":matchId/results" element={<ResultsEntry />} />
          <Route path="formats" element={<FormatsList />} />
          <Route path="formats/new" element={<CreateFormat />} />
          <Route path="formats/:formatId" element={<EditFormat />} />
        </Route>
      )}

      <Route path="facilities">
        <Route index element={
          <Main hasSidebar={true} pageContent={{
            content: {
              title: "Our Facilities",
              subtitle: "",
              image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
            }
          }}>
            <div>
              <p style={{color: 'black', marginBottom: '16px'}}>
                Golden Gun Club sits on 160 acres outside of the town of Watkins, CO. The Club offers two main facilities:
              </p>
              <ul style={{color: 'black', marginLeft: '24px', marginBottom: '16px'}}>
                <li>The Shotgun area, consisting of two dedicated Trap fields, six combination Skeet and Trap fields and a 5 Stand field sprawling across a 160-acre facility.</li>
                <li>The Rifle & Pistol Range consists of 75 firing points from 7 to 500 yards.</li>
              </ul>
              <p style={{color: 'black'}}>
                Please call the clubhouse during inclement weather to check current status.
              </p>
            </div>
          </Main>
        } />
        <Route path="shotgun" element={
          <Main hasSidebar={true} pageContent={{
            content: {
              title: "Our Facilities",
              subtitle: "Trap, Skeet & Sporting Clays",
              image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
            }
          }}>
            <Shotgun />
          </Main>
        } />
        <Route path="rifle-pistol" element={
          <Main hasSidebar={true} pageContent={{
            content: {
              title: "Our Facilities",
              subtitle: "Pistol, Rifle, and Long Range",
              image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
            }
          }}>
            <RiflePistol />
          </Main>
        } />
      </Route>

      <Route path="visitors" element={
        <Main hasSidebar={true} pageContent={{
          content: {
            title: "Visitors",
            subtitle: "",
            image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
          }
        }}>
          <Visitors />
        </Main>
      } />

      <Route path="membership">
        <Route index element={
          <Main hasSidebar={true} pageContent={{
            content: {
              title: "Membership at Golden Gun Club",
              subtitle: "Open for New Member Applications!",
              image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
            }
          }}>
            <Membership />
          </Main>
        } />
        <Route path="range-rules" element={
          <Main hasSidebar={true} pageContent={{
            content: {
              title: "Range Rules",
              subtitle: "",
              image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
            }
          }}>
            <RangeRules />
          </Main>
        } />
      </Route>

      <Route path="matches-competition">
        <Route index element={
          <Main hasSidebar={true} pageContent={{
            content: {
              title: "Match Programs at Golden Gun Club",
              subtitle: "Approachable Competitive Shooting Sports Experiences",
              image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
            }
          }}>
            <MatchesCompetition />
          </Main>
        } />
        <Route path="cowboy-silhouette">
          <Route index element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Match Programs at Golden Gun Club",
                subtitle: "Cowboy Silhouette Match Program",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <CowboySilhouette />
            </Main>
          } />
          <Route path="schedule" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Cowboy Silhouette Match Schedule",
                subtitle: "Upcoming Matches",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <CowboySilhouetteSchedule />
            </Main>
          } />
          <Route path="results" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Cowboy Silhouette Match Results",
                subtitle: "Current Season Standings",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <CowboySilhouetteResults />
            </Main>
          } />
        </Route>
        <Route path="cmp-highpower-service-rifle">
          <Route index element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Match Programs at Golden Gun Club",
                subtitle: "CMP Highpower/Service Rifle",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <CmpHighpower />
            </Main>
          } />
          <Route path="schedule" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "CMP Highpower/Service Rifle Match Schedule",
                subtitle: "Upcoming Matches",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <CmpHighpowerSchedule />
            </Main>
          } />
          <Route path="results" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "CMP Highpower/Service Rifle Match Results",
                subtitle: "Current Season Standings",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <CmpHighpowerResults />
            </Main>
          } />
          <Route path="rifle-purchase" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "CMP Rifle Purchase Information",
                subtitle: "CMP Highpower/Service Rifle",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <CmpRiflePurchase />
            </Main>
          } />
          <Route path="rifle-purchase/membership-form" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "CMP Proof of Membership Form",
                subtitle: "Golden Gun Club",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <MembershipForm />
            </Main>
          } />
        </Route>
        <Route path="bowling-pin-match">
          <Route index element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Match Programs at Golden Gun Club",
                subtitle: "Bowling Pin Match",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <BowlingPinMatch />
            </Main>
          } />
          <Route path="schedule" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Bowling Pin Match Schedule",
                subtitle: "Upcoming Matches",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <BowlingPinMatchSchedule />
            </Main>
          } />
          <Route path="results" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Bowling Pin Match Results",
                subtitle: "Current Season Standings",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <BowlingPinMatchResults />
            </Main>
          } />
        </Route>
        <Route path="black-powder-silhouette">
          <Route index element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Match Programs at Golden Gun Club",
                subtitle: "Black Powder Cartridge Silhouette",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <BlackPowderSilhouette />
            </Main>
          } />
          <Route path="schedule" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Black Powder Silhouette Match Schedule",
                subtitle: "Upcoming Matches",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <BlackPowderSilhouetteSchedule />
            </Main>
          } />
          <Route path="results" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Black Powder Silhouette Match Results",
                subtitle: "Current Season Standings",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <BlackPowderSilhouetteResults />
            </Main>
          } />
        </Route>
        <Route path="nra-action-pistol">
          <Route index element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Match Programs at Golden Gun Club",
                subtitle: "NRA Action Pistol",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <NraActionPistol />
            </Main>
          } />
          <Route path="schedule" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "NRA Action Pistol Match Schedule",
                subtitle: "Upcoming Matches",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <NRAActionPistolSchedule />
            </Main>
          } />
          <Route path="results" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "NRA Action Pistol Match Results",
                subtitle: "Current Season Standings",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <NRAActionPistolResults />
            </Main>
          } />
        </Route>
        <Route path="trap-league">
          <Route index element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Match Programs at Golden Gun Club",
                subtitle: "Trap League",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <TrapLeague />
            </Main>
          } />
          <Route path="trap-league-info" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Trap League Information",
                subtitle: "League Details and Schedule",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <TrapLeagueInfo />
            </Main>
          } />
          <Route path="trap-league-results" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Trap League Results",
                subtitle: "Current Season Standings",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <TrapLeagueResults />
            </Main>
          } />
        </Route>
        <Route path="skeet-league">
          <Route index element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Match Programs at Golden Gun Club",
                subtitle: "Skeet League",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <SkeetLeague />
            </Main>
          } />
          <Route path="skeet-league-info" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Skeet League Information",
                subtitle: "League Details and Schedule",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <SkeetLeagueInfo />
            </Main>
          } />
          <Route path="skeet-league-results" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Skeet League Results",
                subtitle: "Current Season Standings",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <SkeetLeagueResults />
            </Main>
          } />
        </Route>
        <Route path="five-stand-league">
          <Route index element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Match Programs at Golden Gun Club",
                subtitle: "Five Stand League",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <FiveStandLeague />
            </Main>
          } />
          <Route path="five-stand-league-info" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Five Stand League Information",
                subtitle: "League Details and Schedule",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <FiveStandLeagueInfo />
            </Main>
          } />
          <Route path="five-stand-league-results" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Five Stand League Results",
                subtitle: "Current Season Standings",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <FiveStandLeagueResults />
            </Main>
          } />
        </Route>
        <Route path="tournaments">
          <Route index element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Match Programs at Golden Gun Club",
                subtitle: "Registered Tournaments",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <Tournaments />
            </Main>
          } />
          <Route path="tournament-info" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Tournament Signup Information",
                subtitle: "Upcoming Registered Shoots",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <TournamentInfo />
            </Main>
          } />
          <Route path="tournament-results" element={
            <Main hasSidebar={true} pageContent={{
              content: {
                title: "Tournament Results",
                subtitle: "Recent Competition Results",
                image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
              }
            }}>
              <TournamentResults />
            </Main>
          } />
        </Route>
      </Route>

      <Route path="about-us"> 
        <Route index element={
          <Main hasSidebar={true} pageContent={{
            content: {
              title: "About Golden Gun Club",
              subtitle: "Learn about our club, board members, and contact information",
              image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
            }
          }}>
            <AboutUs />
          </Main>
        } />
        <Route path="calendar" element={
          <Main hasSidebar={true} pageContent={{
            content: {
              title: "Club Calendar",
              subtitle: "Upcoming Events and Activities",
              image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
            }
          }}>
            <Calendar />
          </Main>
        } />
        <Route path="board-minutes-notes" element={
          <Main hasSidebar={true} pageContent={{
            content: {
              title: "Member Documents",
              subtitle: "Board Minutes, Financial Statements & Club Materials",
              image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
            }
          }}>
            <Newsletters />
          </Main>
        } />
        <Route path="range-camera" element={
          <Main hasSidebar={true} pageContent={{
            content: {
              title: "Range Camera",
              subtitle: "Live View of Club Facilities",
              image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
            }
          }}>
            <RangeCamera />
          </Main>
        } />
        <Route path="faq" element={
          <Main hasSidebar={true} pageContent={{
            content: {
              title: "About Golden Gun Club",
              subtitle: "Frequently Asked Questions",
              image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-interior.jpg"
            }
          }}>
            <FAQ />
          </Main>
        } />
      </Route>

      <Route path="signup" element={<Signup />} />
      <Route path="verify-email" element={<VerifyEmail />} />

      <Route path="index.html" element={
        <Navigate to="/" />
      } />

      <Route path="*" element={
        <Main>
          <div>Page not found</div>
        </Main>
      } />
    </Routes>
  )
};
